"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.3979 2.414 19.1846 19.1906-1.3978 1.3965-2.9984-2.9993C15.8608 21.231 14.1047 22 12.0001 22c-2.741 0-4.8906-1.3043-6.268-3.231-1.3616-1.9047-1.9634-4.4012-1.7274-6.8644.1318-1.375.525-2.7397 1.0942-3.9939L1 3.8105 2.3979 2.414zm3.5977 9.6814c.0857-.8941.308-1.7946.6326-2.655l1.6039 1.6044A4.4792 4.4792 0 0 0 7.5039 13.5c0 2.4853 2.0147 4.5 4.5 4.5a4.4786 4.4786 0 0 0 2.454-.7274l1.3133 1.3137C14.7977 19.4661 13.5327 20 12.0001 20c-2.0397 0-3.6056-.9457-4.6409-2.394-1.051-1.4703-1.5588-3.4738-1.3636-5.5106zM9.504 13.5c0-.3488.0714-.6809.2004-.9824l3.2813 3.2823A2.4918 2.4918 0 0 1 12.004 16c-1.3807 0-2.5-1.1193-2.5-2.5z"
  }), _react.default.createElement("path", {
    d: "m7.3162 4.505 1.4154 1.4158C9.8608 4.6545 11.0584 4 12.0001 4c1.0602 0 2.4446.8294 3.6906 2.4274 1.2124 1.5548 2.1186 3.628 2.3141 5.668.0954.995.0229 1.982-.1986 2.9028l1.6012 1.6017c.5391-1.4631.7425-3.0863.5883-4.6953-.2358-2.46-1.3085-4.8868-2.7278-6.707C15.8822 3.4206 13.9822 2 12.0001 2c-1.7165 0-3.3713 1.0653-4.684 2.505z"
  }), _react.default.createElement("path", {
    d: "M16.4999 13.6915c.1078-2.5735-2.1159-4.7944-4.6861-4.6876l4.6861 4.6876z"
  })];
};

exports.default = _default;